import React, { useState } from "react";
import "./ContactUsForm.scss";
import axios from "axios";
import { useStateValue } from "../../context/StateProvider";
import emailjs from "emailjs-com";

const Warning = ({ formError }) => {

  return <div className="contact-form-warning">{formError}</div>;
};

const ContactUsForm = () => {
  const [{ cart }, dispatch] = useStateValue();
  const [formData, setFormData] = useState({
    email: "",
    name: "",
    message: "",
  });
  const [formError, setFormError] = useState("");
  const [mode, setMode] = useState("edit");
  const [warningState, setWarningState] = useState(false);

  const handleForm = (e) => {
    setFormError("");
    const toUpdate = { [e.target.name]: e.target.value };
    setFormData({ ...formData, ...toUpdate });
  };

  const clearForm = () => {
    setFormData({
      email: "",
      name: "",
      message: "",
    });
    setMode("edit");
    console.log("form cleared");
  };

  const sendEmail = (event) => {
    event.preventDefault();
    if (!formData.email.length) {
      setWarningState(true);
      return setFormError("*Please add your email");
    }
    if (!formData.name.length) {
      setWarningState(true);
      return setFormError("*Please add your name");
    }
    if (!formData.message.length) {
      setWarningState(true);
      return setFormError("*Please enter your message");
    }

    emailjs
      .sendForm(
        "its-my-wine-orders",
        "template_ae5wscl",
        event.target,
        "user_wFX3tNr4hTywlZiCqN0LQ"
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );

    console.log("confirming");
    setMode("confirmation");
  };
  return (
    <form className="contact-form" onSubmit={sendEmail}>
      <h4>{mode === "edit" ? "Please get in touch: " : "Message Sent"}</h4>

      {mode === "edit" && (
        <>
          <div className="form-row-contact">
            <input
              type="text"
              name="email"
              placeholder="Email"
              value={formData.email}
              onChange={handleForm}
            />
          </div>
          <div className="form-row-contact">
            <input
              type="text"
              name="name"
              value={formData.name}
              placeholder="Name"
              onChange={handleForm}
            />
          </div>
          <div className="form-row-contact">
            <input
              type="text"
              name="message"
              value={formData.message}
              placeholder="Message"
              style={{
                width: "100%",
                height: "200px",
                display: "flex",
                alignContent: "flex-start",
              }}
              onChange={handleForm}
            />
          </div>

          <div className="form-row-contact submit-btn">
            <input
              type="submit"
              value="Send"
              className="button"
              // onClick={handleSubmitOrder}
            >
              {/* <span>Submit</span> */}
            </input>
            {warningState && <Warning formError={formError} />}
          </div>
        </>
      )}

      {mode === "confirmation" && (
        <>
          <p className="confirmation-message">
            Your Message was sent! Check your email for a confirmation, you will
            receive an answer from It's My Wine as soon as possible!
          </p>

          <button className="button" onClick={clearForm}>
            Send Another Message
          </button>
        </>
      )}
    </form>
  );
};

export default ContactUsForm;
